import type { MyIpDraftSnapshot } from './types';
import { rebaseMyIpResources } from './resourceSlots';

/** JSON 主档中的对象递归合并；数组作为字段处理，不按位置猜测对象身份。 */
function isObject(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

/** 仅把本地相对编辑基线的差异应用到新详情，保留远端未被本地编辑的字段。 */
function rebaseValue(base: unknown, local: unknown, latest: unknown): unknown {
  if (JSON.stringify(base) === JSON.stringify(local)) return latest;
  if (!isObject(local) || !isObject(latest)) return local;
  const original = isObject(base) ? base : {};
  const merged = { ...latest };
  for (const key of new Set([...Object.keys(original), ...Object.keys(local)])) {
    if (JSON.stringify(original[key]) !== JSON.stringify(local[key])) {
      if (!Object.hasOwn(local, key)) delete merged[key];
      else {
        Object.defineProperty(merged, key, {
          value: rebaseValue(original[key], local[key], latest[key]), enumerable: true, configurable: true, writable: true,
        });
      }
    }
  }
  return merged;
}

/** 冲突恢复时主字段做三方合并，素材沿用已有新增/删除意图协议。 */
export function rebaseMyIpSnapshot(
  base: MyIpDraftSnapshot,
  local: MyIpDraftSnapshot,
  latest: MyIpDraftSnapshot,
): MyIpDraftSnapshot {
  const merged = rebaseValue(base, local, latest) as MyIpDraftSnapshot;
  const localSync = local.profile.material_sync;
  const remoteSync = latest.profile.material_sync;
  if (isObject(localSync) && isObject(remoteSync) && localSync.schema_version === 1 && remoteSync.schema_version === 1
    && Array.isArray(localSync.removed) && Array.isArray(remoteSync.removed)) {
    merged.profile = {
      ...merged.profile,
      material_sync: {
        ...remoteSync,
        ...(merged.profile.material_sync as object),
        removed: [...new Set([...remoteSync.removed, ...localSync.removed])],
      },
    };
  }
  if (local.resources) merged.resources = rebaseMyIpResources(base.resources || [], local.resources, latest.resources || []);
  else if (latest.resources) merged.resources = latest.resources;
  return merged;
}
